import { getItem } from '../data/items.js';
import { LOOT_POOLS } from '../data/loot.js';
import { MERCHANT_MARKUP, MERCHANT_REACH, MERCHANT_SUPPLIES } from '../data/merchant.js';
import { TUTORIAL_SET, TUTORIAL_ZONE_ID } from '../data/tutorial.js';
/**
 * Selling to the merchant (ADR 0016): what he pays, and who he talks to.
 * Pure; the server applies the sale, the client previews it with the same
 * functions.
 */
/** Whether the merchant takes it at all: anything with a price. */
export function isSellable(template) {
    return template.sellPrice > 0;
}
/** Gold paid for `quantity` of a template: its sell price each, nothing for the worthless. */
export function sellValue(template, quantity) {
    if (!isSellable(template) || !Number.isInteger(quantity) || quantity < 1)
        return 0;
    return template.sellPrice * quantity;
}
/** Within `MERCHANT_REACH` tiles of one of these merchants, diagonals included. */
export function withinMerchantReach(at, merchants) {
    return merchants.some((merchant) => Math.max(Math.abs(merchant.x - at.x), Math.abs(merchant.y - at.y)) <= MERCHANT_REACH);
}
/**
 * What a merchant sells, by the biome he stands in (loot ADR 0012: nobody is
 * left stuck by bad luck): the common pieces of that biome's pool, then the
 * supplies every merchant keeps. Template ids, in that order. The tutorial's
 * merchant sells the tutorial's wooden set instead, which no biome drops.
 */
export function merchantStock(biome, zoneId) {
    const pieces = zoneId === TUTORIAL_ZONE_ID ? TUTORIAL_SET : LOOT_POOLS[biome].common;
    return [...pieces, ...MERCHANT_SUPPLIES].filter((id) => getItem(id) !== undefined);
}
/** What the merchant asks for one: `MERCHANT_MARKUP` times what he would pay, one coin at least. */
export function buyPrice(template) {
    return Math.max(1, template.sellPrice * MERCHANT_MARKUP);
}
//# sourceMappingURL=merchant.js.map